import Editor from '@draft-js-plugins/editor';
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from '@draft-js-plugins/mention';
// import '@draft-js-plugins/mention/lib/plugin.css';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
// import '@draft-js-plugins/linkify/lib/plugin.css';
import createLinkPlugin from '@draft-js-plugins/anchor';
import createInlineToolbarPlugin from '@draft-js-plugins/inline-toolbar';
import { ItalicButton, BoldButton, UnderlineButton } from '@draft-js-plugins/buttons';
import { CompositeDecorator, EditorState, Modifier } from 'draft-js';
// import 'draft-js/dist/Draft.css';
import debounce from 'lodash/debounce';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import css from './CircleBlockEditor.module.css';


const linkPlugin = createLinkPlugin();



// const mentionStrategy = (contentBlock, callback, contentState) => {
//   const text = contentBlock.getText();
//   let matchArr, start;
//   const regex = /@\w+/g; // Detect mentions starting with '@'
//   while ((matchArr = regex.exec(text)) !== null) {
//     start = matchArr.index;
//     callback(start, start + matchArr[0].length);
//   }
// };

// const Mention = props => (
//   <span style={{ backgroundColor: '#e8f5ff', color: '#0073e6' }}>{props.children}</span>
// );

// const compositeDecorator = new CompositeDecorator([
//   {
//     strategy: mentionStrategy,
//     component: Mention,
//   },
// ]);





const CircleBlockEditor = props => {
  const {
    editorState,
    setEditorState,
    advancedSearchData = {} ,
    onAdvancedSearch,
    replyCommentPlaceHolder = '',
    hasAttachment = false
  } = props;
  const {records = [] } = advancedSearchData || {}

  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState(defaultSuggestionsFilter('', records));

  //infinit render issue fixed
  const debouncedSetSuggestions = useCallback(
    debounce((newSuggestions) => {
      setSuggestions(newSuggestions);
    }, 100),
    []
  );

  // useEffect(() => {
  //   // Automatically focus the editor when the component mounts
  //   ref.current.focus();
  // }, []);

  useEffect(() => {
    if (records.length === 0) return;

    const newSuggestions = defaultSuggestionsFilter('', records);
    debouncedSetSuggestions(newSuggestions);

    return () => {
      debouncedSetSuggestions.cancel();
    };
  }, [records, debouncedSetSuggestions]);

  const { MentionSuggestions, plugins } = useMemo(() => {
    const mentionPlugin = createMentionPlugin();
    // Initialize the Linkify plugin
    const linkifyPlugin = createLinkifyPlugin();
    const inlineToolbarPlugin = createInlineToolbarPlugin();
    // eslint-disable-next-line no-shadow
    const { MentionSuggestions } = mentionPlugin;
    // const { InlineToolbar } = inlineToolbarPlugin;
    // eslint-disable-next-line no-shadow
    const plugins = [mentionPlugin, linkifyPlugin, inlineToolbarPlugin];
    return { plugins, MentionSuggestions };
  }, []);

  const onOpenChange = useCallback((_open) => {
    setOpen(_open);
  }, []);

   const debouncedSearch = useCallback(
      debounce((searchQuery) => {
        console.log('searchQuery', searchQuery)
        onAdvancedSearch({ query: searchQuery })
      }, 500),
      []
    );

  const onSearchChange = (value) => {
    debouncedSearch(value?.value);
  }

  // const [linkInput, setLinkInput] = useState('');

  // const addLink = () => {
  //   const selection = editorState.getSelection();

  //   if (!selection.isCollapsed()) {
  //     const url = window.prompt('Enter the URL'); // Show a prompt to enter the URL
  //     if (url) {
  //       const contentState = editorState.getCurrentContent();
  //       const contentWithEntity = contentState.createEntity('LINK', 'MUTABLE', { url });
  //       const entityKey = contentWithEntity.getLastCreatedEntityKey();
  //       const newEditorState = EditorState.push(
  //         editorState,
  //         Modifier.applyEntity(contentWithEntity, selection, entityKey),
  //         'apply-entity'
  //       );
  //       setEditorState(newEditorState);
  //     }
  //   }
  // };

  return (
    <div
      className={hasAttachment ? css.inputAttachmentBoxWrapper : css.inputBoxWrapper}
      onClick={() => {
        ref.current.focus();
      }}
    >
      <Editor
        className={css.editorBox}
        placeholder={replyCommentPlaceHolder || 'Write something...'}
        editorKey={'editor'}
        editorState={editorState}
        onChange={setEditorState}
        plugins={plugins}
        ref={ref}
      />
      <MentionSuggestions
        open={open}
        onOpenChange={onOpenChange}
        suggestions={suggestions}
        onSearchChange={onSearchChange}
        onAddMention={(item) => {
          console.log('item', item);
        }}

      />
    </div>
  );
};

export default CircleBlockEditor



// {
//   mentionComponent(mentionProps) {
//     return (
//       <span
//         className={mentionProps.className}
//         // eslint-disable-next-line no-alert
//         onClick={() => alert('Clicked on the Mention!')}
//       >
//         {mentionProps.children}
//       </span>
//     );
//   },
// }